module.exports = __webpack_public_path__ + "img/header@2x.4b330a59.png";